import * as Types from '../../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAiFeedbackMutationVariables = Types.Exact<{
  input: Types.CreateAiFeedbackInput;
}>;


export type CreateAiFeedbackMutation = { __typename?: 'Mutation', createAIFeedback: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null } };


export const CreateAiFeedbackDocument = gql`
    mutation CreateAIFeedback($input: CreateAIFeedbackInput!) {
  createAIFeedback(input: $input) {
    success
    error {
      code
      message
    }
  }
}
    `;
export type CreateAiFeedbackMutationFn = Apollo.MutationFunction<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>;

/**
 * __useCreateAiFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateAiFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiFeedbackMutation, { data, loading, error }] = useCreateAiFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>(CreateAiFeedbackDocument, options);
      }
export type CreateAiFeedbackMutationHookResult = ReturnType<typeof useCreateAiFeedbackMutation>;
export type CreateAiFeedbackMutationResult = Apollo.MutationResult<CreateAiFeedbackMutation>;
export type CreateAiFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>;